export default "__VITE_ASSET__BkKC72P3__"